// extracted by mini-css-extract-plugin
module.exports = {"bg":"GameDouble_bg__3pQt8","img":"GameDouble_img__1q8xK","active":"GameDouble_active__2wK9A"};